import React from 'react';
import { HeaderBackground } from 'app/components/HeaderBar/HeaderBackground';
import { HeaderLogo } from 'app/components/HeaderBar/HeaderLogo';
import { VisitSessionLink } from 'app/components/HeaderBar/VisitSessionLink';
import { PageNotFound } from 'app/views/PageNotFound';

export const WebPageNotFound = () => (
  <>
    <HeaderBackground isSignedOutWeb>
      <HeaderLogo options={{ isSignedOutWeb: true }} />
      <VisitSessionLink />
    </HeaderBackground>
    <PageNotFound />
  </>
);
